const drawing = {
    "drawAt": "",
    "drawCode": "",
    "drawLabel": "",
    "results": [
        {
            "postCode": "A",
            "number": ""
        },
        {
            "postCode": "B",
            "number": ""
        },
        {
            "postCode": "C",
            "number": ""
        },
        {
            "postCode": "D",
            "number": ""
        }
    ]
}

export {
    drawing
}